import UserInterface from "@/types_and_interfaces/user_interface.ts";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import InstallmentsInterface from "@/types_and_interfaces/installments_interface.ts";
import {
    ApplicationStatus,
    AuthType, CreditStatusSimplified, CreditTypes,
    DisturbedType,
    InstallmentType,
    KYCGeneralStatus,
    KycItemType,
    LoanTypes, NotificationInfoType, NotificationType, StandartCreditStatus, UserType
} from "@/types_and_interfaces/types.ts";
import RepresentedIdentityInterface from "@/types_and_interfaces/represented_identity_interface.ts";
import UserPermisionsInterface from "@/types_and_interfaces/user_permisions_interface.ts";
import KYCInterface from "@/types_and_interfaces/kyc_interface.ts";
import CalculatorLimitTypes from "@/types_and_interfaces/calculator_limit_types.ts";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
import CreditApplicationInterface from "@/types_and_interfaces/credit_application_interface.ts";
import LoanApplicationTypesInterface from "@/types_and_interfaces/loan_types_interface.ts";
import NotificationInterface from "@/types_and_interfaces/notification_interface.ts";
import PaymentMethodsObjInterface from "@/types_and_interfaces/payment_methods_obj_interface.ts";
import PaymentMethodInterface from "@/types_and_interfaces/payment_method_interface.ts";
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";
import PaymentsInterface from "@/types_and_interfaces/payments_interface.ts";
import CMS from "@/utils/cms.ts";
import Images from "@/utils/images.ts";
import {application_keys} from "@/utils/constants.ts";
import {ApplicationsAndCrLineStatuses} from "@/types_and_interfaces/enums.ts";
// import { OTPDataObject} from "@/types_and_interfaces/types.ts";


class Factories {
    
    static user_factory = (json:any):UserInterface => {
        
        function represented_identity(x:any):RepresentedIdentityInterface {
            return {
                id: typeof x["id"] === "string" ? x["id"] : "",
                type: typeof x["type"] === "number" ? generate_user_type(x["type"]) : "PJ",
                idnx: typeof x["idnx"] === "string" ? x["idnx"] : "",
                name: typeof x["name"] === "string" ? x["name"] : "",
            }
        }
        
        function generate_user_type(x:number):UserType {
            if(x === 1) return "PF"
            else if(x === 2) return "PJ"
            else return "PF"
        }
        
        function permissions(x:any):UserPermisionsInterface {
            return {
                is_email_modifiable: x["is_email_modifiable"] || false,
                is_pass_code_modifiable: x["is_pass_code_modifiable"] || false,
                is_loan_application_allowed: x["is_loan_application_allowed"] || false,
                is_transaction_application_allowed: x["is_transaction_application_allowed"] || false,
                is_loan_personal_or_refinance_allowed: x["is_loan_personal_or_refinance_allowed"] || false,
                is_loan_auto_allowed: x["is_loan_auto_allowed"] || false,
                is_phone_modifiable: x["is_phone_modifiable"] || false,
                is_kyc_allowed: x["is_kyc_allowed"] || false
            }
        }
        
        function kyc(x:any):KYCInterface {
            
            return {
                identity_card: kyc_items_status_handle(x.identity_card.status),
                liveness: kyc_items_status_handle(x.liveness.status),
                face_comparison: kyc_items_status_handle(x.liveness.face_comparison),
                success_finished_at: x?.success_finished_at || "0"
            }
        }
        
        function generate_kyc_general_status(x:any):KYCGeneralStatus {
            
            if(x.identity_card.status === 0){
                return "Unknown"
                
            } else if (x?.has_asp_kyc_conflict || x?.identity_card_is_expired || x?.identity_card_is_expiring_soon) {
                return "Expired"

            } else if(x.identity_card.status === 1 || x.liveness.status === 1 || (x.identity_card.status === 4 && x.liveness.status === 1)){
                return "UserStarted"
                
            }  else if(x.identity_card.status === 5 || x.liveness.status === 5 || x.face_comparison.status === 5){
                return "ProcessingFailed"
                
            } else if(x.identity_card.status === 6 || x.liveness.status === 6 || x.face_comparison.status === 6 ){
                return "ProcessingFailedAndSentToManager"
                
            } else if(x.identity_card.status === 4 && x.liveness.status === 4 && x.face_comparison.status === 4){
                return "ProcessingSuccess"
                
            } else if(x.identity_card.status === 3 || x.liveness.status === 3 || x.face_comparison.status === 3){
                return "ServerProcessing"
                
            } else if(x.identity_card.status === 2 || x.liveness.status === 2 || x.face_comparison.status === 2){
                return "UserFinished"
                
            } else if(x.identity_card.status === 4 && x.liveness.status === 4 && x.face_comparison.status === 0){
                return "ServerProcessing"
                
            } else if(x.identity_card.status === 4 && x.liveness.status === 0 && x.face_comparison.status === 0){
                return "UserStarted"

            } else return "ProcessingFailed"
            
        }
        
        function kyc_items_status_handle(x:number):KycItemType{
            if(x === 0) return "Unknown"
            else if(x === 1) return "UserStarted"
            else if(x === 2) return "UserFinished"
            else if(x === 3) return "ServerProcessing"
            else if(x === 4) return "ProcessingSuccess"
            else if(x === 5) return "ProcessingFailed"
            else if(x === 6) return "ProcessingFailedAndSentToManager"
            else return "Unknown"
        }
        
        function auth_type(x:number):AuthType {
            if(x === 1) return "ByPass"
            else if(x === 2) return "ByMPass"
            else if(x === 3) return "ByPin"
            else if(x === 4) return "ByGoogleUID"
            else if(x === 5) return "ByEmail"
            else if(x === 6) return "ByPhone"
            else if(x === 7) return "ByPassCode"
            else return "Unknown"
        }
        
        let usr: UserInterface = {
            id: typeof json["id"] === "string" ? json["id"] : "",
            my_identity_id: typeof json["my_identity_id"] === "string" ? json["my_identity_id"] : "",
            first_name: typeof json["first_name"] === "string" ? json["first_name"] : "",
            last_name: typeof json["last_name"] === "string" ? json["last_name"] : "",
            phone: typeof json["phone"] === "string" ? json["phone"] : "",
            email: typeof json["email"] === "string" ? json["email"] : "",
            role: typeof json["role"] === "number" ? json["role"] : 0,
            idnx: typeof json["idnx"] === "string" ? json["idnx"] : "",
            birthday: typeof json["birth_date"] === "string" ? json["birth_date"] : "",
            is_pass_code_set: typeof json["is_pass_code_set"] === "boolean" ? json["is_pass_code_set"] : false,
            is_email_set: typeof json["is_email_set"] === "boolean" ? json["is_email_set"] : false,
            auth_type:auth_type(json["auth_type"]),
            display_name: typeof json["display_name"] === "string" ? json["display_name"] : "",
            represented_identity: represented_identity(json["represented_identity"]),
            permissions: permissions(json["permissions"]),
            kyc: kyc(json["kyc"]),
            kyc_general_status:generate_kyc_general_status(json["kyc"]),
            has_asp_kyc_conflict: typeof json["has_asp_kyc_conflict"] === "boolean" ? json["has_asp_kyc_conflict"] : false,
            identity_card_is_expired: typeof json["identity_card_is_expired"] === "boolean" ? json["identity_card_is_expired"] : false,
            identity_card_is_expiring_soon: typeof json["identity_card_is_expiring_soon"] === "boolean" ? json["identity_card_is_expiring_soon"] : false,
        }
        
        return usr
    }
    
    static transactions_factory = (json:any, payments:any):Array<CrLineTransactionInterface> => {
        
        if(Array.isArray(json) && json.length) {
            let res:Array<CrLineTransactionInterface> = []
            
            json.map((x) => {
                
                const transaction_payments = payments?.filter((y:PaymentsInterface) => y.urn === x.urn_tr)
                
                const total_paid = transaction_payments?.reduce((sum:number, item:PaymentsInterface) => sum + Number(item.amount), 0) || 0
                
                res.push({
                    amount: typeof x["amount"] === "string" ? x["amount"] : "",
                    client_loan_id: typeof x["client_loan_id"] === "string" ? x["client_loan_id"] : "",
                    created_at: typeof x["created_at"] === "string" ? x["created_at"] : "",
                    id: typeof x["id"] === "string" ? x["id"] : "",
                    status: application_keys.includes(x["status"].toLowerCase()) ? x["status"].toLowerCase() : "unknown",
                    status_simplified: application_keys.includes(x["status"].toLowerCase()) ? this.application_status_simplification(x["status"].toLowerCase()) : "pending",
                    trans_document_status: typeof x["trans_document_status"] === "string" ? x["trans_document_status"] : "",
                    urn_tr: typeof x["urn_tr"] === "string" ? x["urn_tr"] : "",
                    paid: total_paid,
                    fully_paid: x["status"].toLowerCase() === "closed",
                    restant: false
                })
            })
            
            res.sort((a:any, b:any) => {
                return   new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            });
            
            return res
        } else return []
    }
    
    static payments_factory = (list:Array<any>) => {
        
        let res:Array<PaymentsInterface> = []
        
        const all_banks = CMS.banks?.repeater ?? []
        const online_payment = CMS.online_payment?.repeater ?? []
        const e_payments = CMS.e_payments?.repeater ?? []
        const stores = CMS.stores?.repeater ?? []

        const all_payment_methods = [...all_banks, ...online_payment, ...e_payments, ...stores]
        
        function format_date(date:string):string {
            
            const [year, month, day] = date.split('-')/*.map(Number)*/;

            return `${day}.${month.length === 1 ? `0${month}`: month}.${year}`
        }

        if(Array.isArray(list) && list.length) {
            list.forEach((x:any) => {
                
                let cms_method = all_payment_methods.find( (p) => x.location.replace(" ", "").toLowerCase().includes(p.label.toLowerCase()) )
                
                let item = {
                    id: typeof x.id === "string" ? x.id : "",
                    client_loan_id: typeof x.client_loan_id === "string" ? x.client_loan_id : "",
                    urn: typeof x.urn === "string" ? x.urn : "",
                    payment_date: typeof x.payment_date === "string" ? format_date(x.payment_date) : "",
                    amount: typeof x.amount === "string" ? x.amount : "",
                    location: typeof x.location === "string" ? x.location : "",
                    type: (typeof x.type === "string" && (x.type === "Payed" || x.type === "WithDrawal"))  ? x.type : "",
                    img: cms_method ? CMS.getFilePath(cms_method.label_image[0].path) : "",
                    // img: ""
                }
                
                if(x.location.toLowerCase().includes("easy credit") || x.location.toLowerCase().includes("easycredit")) {
                    item.img = Images.logos.TextlessLogo
                }
                
                res.push(item)
            })
        }
        
        return res
    }
    
    static r_status_simplified_factory = (x:StandartCreditStatus):CreditStatusSimplified => {
        if(x === "unknown") {
            return "unknown"
            
        } else if(x === "processing" || x === "moredata" || x === "uncommitted") {
            return "pending"
            
        } else if(x === "notok" || x === "rejected" || x === "canceled") {
            return "danger"
            
        } else if(x === "approved" || x === "new" || x === "disbursed" || x === "settled") {
            return "success"
            
        } else return "unknown"
    }
    
    static loan_factory = (json:any):LoanInterface => {
        
        const formatDate = (dateString:string) =>{
            const date = new Date(dateString);
            
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            
            return `${day}/${month}/${year}`;
        }
        
        let inst:Array<InstallmentsInterface> = []
        let total_aomunt:number = 0
        
        if(Array.isArray(json["installments"]) && json["installments"].length) {
            let arr = json["installments"]
            inst = arr.map((obj:any) => {
                return this.installments_factory(obj)
            })
            
            inst = inst.sort((a, b) => {
                const dateA = a.date ? new Date(a.date) : new Date(0);
                const dateB = b.date ? new Date(b.date) : new Date(0);
                return dateA.getTime() - dateB.getTime();
            });
            inst.forEach((x) => {
                try {
                    const [year, month, day] = x.date?.split('-');
    
                    const reformattedDate = `${day}.${month}.${year}`;
                    x.date = reformattedDate
                    
                } catch (e) {
                    console.error(e, x.date)
                }
            })
        }
        
        const calc_billing_deadine = (targetDate:string) => {
            const currentDate:any = new Date();
            
            const target:any = new Date(targetDate);
            
            const differenceInMillis = target - currentDate;
            
            const differenceInDays = Math.ceil(differenceInMillis / (1000 * 60 * 60 * 24));
            
            return differenceInDays;
        }
        
        function calc_days_deadine(targetDate:string) {
            const [day, month, year] = targetDate.split('/');
            
            const target:any = new Date(`${year}-${month}-${day}`);
            
            const currentDate:any = new Date();
            
            const differenceInMillis = target - currentDate;
            
            const differenceInDays = Math.ceil(differenceInMillis / (1000 * 60 * 60 * 24));
            
            return differenceInDays;
        }
        
        const payments = (x:any) => {
            const sorted_payments = Array.isArray(x["payments"]) ?
                x["payments"]?.sort((a:any, b:any) => new Date(a.payment_date).getTime() - new Date(b.payment_date).getTime())
                : [];

            return this.payments_factory(sorted_payments)
        }
        // const total_paid = filtered.reduce((sum, item) => sum + Number(item.amount), 0) || 0
        if(inst.length) {
            total_aomunt = inst.reduce((sum, item) => sum + Number(item.amount), 0) || 0
        }
       
        let loan:LoanInterface = {
            id: typeof json["id"] === "string" ? json["id"] : "",
            user_id: typeof json["user_id"] === "string" ? json["user_id"] : "",
            urn: typeof json["urn"] === "string" ? json["urn"] : "",
            product_group: typeof json["product_group"] === "string" ? (json["product_group"] as LoanTypes) : "",
            product_name: typeof json["product_name"] === "string" ? (json["product_name"] as CreditTypes) : "",
            capital: typeof json["capital"] === "string" ? json["capital"] : "",
            nr_of_installments: typeof json["nr_of_installments"] === "number" ? json["nr_of_installments"] : 0,
            installments_paid: typeof json["installments_paid"] === "number" ? json["installments_paid"] : 0,
            shop_group: typeof json["shop_group"] === "string" ? json["shop_group"] : "",
            shop_name: typeof json["shop_name"] === "string" ? json["shop_name"] : "",
            shop_city: typeof json["shop_city"] === "string" ? json["shop_city"] : "",
            shop_address: typeof json["shop_address"] === "string" ? json["shop_address"] : "",
            shop_zip: typeof json["shop_zip"] === "string" ? json["shop_zip"] : "",
            document_received_at: typeof json["document_received_at"] === "string" ? json["document_received_at"] : null,
            document_status: typeof json["document_status"] === "string" ? json["document_status"] : "",
            r_status: typeof json["r_status"] === "string" ? json["r_status"].toLowerCase() as StandartCreditStatus : "unknown",
            status: typeof json["status"] === "string" ? json["status"].toLowerCase() as ApplicationsAndCrLineStatuses : ApplicationsAndCrLineStatuses.unknown,
            r_status_simplified: this.r_status_simplified_factory(json["r_status"].toLowerCase() as StandartCreditStatus),
            pay_date: typeof json["pay_date"] === "string" ? json["pay_date"] : "",
            pay_date_dublicate: typeof json["pay_date"] === "string" ? json["pay_date"] : "",
            inst_amount: typeof json["inst_amount"] === "string" ? json["inst_amount"] : "",
            disc_amount: typeof json["disc_amount"] === "string" ? json["disc_amount"] : "",
            avail_capital: typeof json["avail_capital"] === "string" ? json["avail_capital"] : "",
            loan_age: typeof json["loan_age"] === "number" ? json["loan_age"] : 0,
            disturbed: typeof json["disturbed"] === "string" ? (json["disturbed"] as DisturbedType) : "No",
            billing_date: typeof json["billing_date"] === "string" ? json["billing_date"] : null,
            installments: inst.length ? inst : [],
            payments:  payments(json),
            payd_payments:  [],
            transactions: Array.isArray(json["transactions"]) ? this.transactions_factory(json["transactions"], payments(json)) : null,
            origin_created_at: typeof json["origin_created_at"] === "string" ? json["origin_created_at"] : "",
            created_at: typeof json["created_at"] === "string" ? json["created_at"] : "",
            updated_at: typeof json["updated_at"] === "string" ? json["updated_at"] : "",
            restant_days: typeof json["loan_age"] === "number" ? json["loan_age"] : 0,
            total_line_paid: 0,
            billing_deadline_days: typeof json["billing_date"] === "string" ? calc_billing_deadine(json["billing_date"]) : 0,
            pay_deadline_days: typeof json["pay_date"] === "string" ? calc_days_deadine(json["pay_date"]) : 0,
            total_amount: total_aomunt,
            is_transaction_application_allowed:  typeof json["is_transaction_application_allowed"] === "boolean" ? json["is_transaction_application_allowed"] : false,
            is_enable_to_sign: typeof json["is_enable_to_sign"] === "boolean" ? json["is_enable_to_sign"] : false,
            is_contract_downloadable: typeof json["is_contract_downloadable"] === "boolean" ? json["is_contract_downloadable"] : false
            // otp: typeof json["otp"] === "object" ? json["otp"] as OTPDataObject : null,
        }
        
        if(loan.pay_date === "Overdue" && loan.installments?.length) {

            
            let last_overdue = loan.installments[loan.installments.length - 1]
            
            loan.installments.forEach((x:InstallmentsInterface) => {
                if(x.status === "Overdue") {
                    last_overdue = x
                }
            })
            
            const new_date = last_overdue.date.replace(/\./g, '/')
            
            if(new_date.length) {
                
                Object.defineProperty(loan, 'pay_date_dublicate', {
                    value: new_date,
                    writable: true,
                    configurable: true,
                    enumerable: true
                });
                
                Object.defineProperty(loan, 'pay_date', {
                    value: new_date,
                    writable: true,
                    configurable: true,
                    enumerable: true
                });
                
            }

        }
        
        if(loan.product_group !== "Credit Line") {
            loan.pay_date = typeof json["billing_date"] === "string" ? formatDate(json["billing_date"]) : ""
            loan.pay_date_dublicate = typeof json["billing_date"] === "string" ? formatDate(json["billing_date"]) : ""
            
        }
        
        if(loan.payments?.length && loan.product_group === "Credit Line") {
            
            let filtered = loan.payments?.filter((x) => x.type === "Payed")
            
            if(filtered?.length) {
                loan.payd_payments = filtered
                
                const total_paid = filtered.reduce((sum, item) => sum + Number(item.amount), 0) || 0
                
                if(total_paid) {
                    loan.total_line_paid = total_paid
                    loan.total_amount -= total_paid
                }
            }
            
        }

        return loan
        
    }
    
    
    static installments_factory = (json:any):InstallmentsInterface => {
        
        function daysUntil(dateString: string): number {
            
            const [year, month, day] = dateString.split('-').map(Number);
            const targetDate = new Date(year, month - 1, day);
            
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            const differenceInTime = today.getTime() - targetDate.getTime();
            
            const days = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
            
            return days;
        }
        

        
        let inst:InstallmentsInterface = {
            id: typeof json["id"] === "string" ? json["id"] : "",
            client_loan_id: typeof json["client_loan_id"] === "string" ? json["client_loan_id"] : "",
            date: typeof json["date"] === "string" ? json["date"] : "",
            amount: typeof json["amount"] === "string" ? json["amount"] : "0",
            status: typeof json["status"] === "string" ? (json["status"] as InstallmentType) : "",
            created_at: typeof json["created_at"] === "string" ? json["created_at"] : "",
            updated_at: typeof json["updated_at"] === "string" ? json["updated_at"] : "",
            restant_days: daysUntil(json["date"]) ? daysUntil(json["date"]) : 0,
            original_json: json || {}
        }
        
        return inst
        
    }
    
    static calculator_limits_factory = (json: any): CalculatorLimitTypes => {
        let res: Partial<CalculatorLimitTypes> = {};
        
        if (typeof json === 'object' && Object.keys(json).length) {
            Object.keys(json).forEach((key) => {
                if (key === 'auto' || key === 'refinance' || key === 'personal') {
                    res[key] = this.calculator_limit(json[key]);
                }
            });
        }
        
        return res as CalculatorLimitTypes;
    };
    
    static calculator_limit = (json: any): CalculatorLimit => {
        return {
            category_id: json["category_id"] || '',
            category_name: json["category_name"] || '' as CreditTypes,
            increment_value: typeof json["increment_value"] === "number" ? json["increment_value"] : 0,
            min_amount: typeof json["min_amount"] === "string" ? Number(json["min_amount"]) : 0,
            max_amount: typeof json["max_amount"] === "string" ? Number(json["max_amount"]) : 0,
            max_installments: typeof json["max_installments"] === "number" ? json["max_installments"] : 0,
            min_installments: typeof json["min_installments"] === "number" ? json["min_installments"] : 0,
            default_capital: typeof json["default_capital"] === "number" ? json["default_capital"] : 0,
            default_month: typeof json["default_month"] === "number" ? json["default_month"] : 0,
            order_number: typeof json["order_number"] === "number" ? json["order_number"] : 0,
        };
    };
    
    static product_factory = (json:any):ProductInterface => {
        return {
            months: typeof json["Months"] === "number" ? json["Months"] : 0,
            penalty: typeof json["Penalty"] === "string" ? Number(json["Penalty"]) : 0,
            name: typeof json["Name"] === "string" ? json["Name"] : "",
            min_months: typeof json["MinMonths"] === "number" ? json["MinMonths"] : 0,
            max_months: typeof json["MaxMonths"] === "number" ? json["MaxMonths"] : 0,
            min_amount: typeof json["MinAmount"] === "string" ? Number(json["MinAmount"]) : 0,
            max_amount: typeof json["MaxAmount"] === "string" ? Number(json["MaxAmount"]) : 0,
            payable_amount: typeof json["PayableAmount"] === "string" ? Number(json["PayableAmount"]) : 0,
            dae: typeof json["DAE"] === "string" ? Number(json["DAE"]) : 0,
            capital: typeof json["Capital"] === "string" ? Number(json["Capital"]) : 0,
            commission_rate: typeof json["ComissionRate"] === "string" ? Number(json["ComissionRate"]) : 0,
            family: typeof json["Family"] === "string" ? json["Family"] : "",
            product_id: typeof json["ProductID"] === "number" ? json["ProductID"] : 0,
            fixed_expenses:  typeof json["FixedExpenses"] === "string" ? Number(json["FixedExpenses"]) : 0,
            id: typeof json["ID"] === "string" ? json["ID"] : '',
            installment_amount: typeof json["InstallmentAmount"] === "string" ? Number(json["InstallmentAmount"]) : 0,
            interest_rate: typeof json["InterestRate"] === "string" ? Number(json["InterestRate"]) : 0,
        }
    }
    
    static goods_name_factory = (x:string):CreditTypes => {
        if(x === "Personal Normal") return "personal"
        else if(x === "Auto") return "auto"
        else return ""
    }
    
    
    static application_factory = (json:any):CreditApplicationInterface => {
        
        return {
            id: typeof json["id"] === "string" ? json["id"] : "",
            product_id: typeof json["product_id"] === "number" ? json["product_id"] : 0,
            urn: typeof json["urn"] === "string" ? json["urn"] : "",
            r_status: (typeof json["r_status"] === "string" && application_keys.includes(json["r_status"].toLowerCase() as ApplicationsAndCrLineStatuses)) ? json["r_status"].toLowerCase()  as ApplicationsAndCrLineStatuses : ApplicationsAndCrLineStatuses.unknown,
            created_at: typeof json["created_at"] === "string" ? json["created_at"] : "",
            installment_amount: typeof json["installment_amount"] === "string" ? json["installment_amount"] : "",
            product_name: typeof json["product_name"] === "string" ? json["product_name"] as CreditTypes: "",
            document_status: typeof json["document_status"] === "string" ? json["document_status"] : "",
            status: (typeof json["status"] === "string" && application_keys.includes(json["status"].toLowerCase() as ApplicationsAndCrLineStatuses)) ? json["status"].toLowerCase()  as ApplicationsAndCrLineStatuses : ApplicationsAndCrLineStatuses.unknown,
            nr_of_installments: typeof json["nr_of_installments"] === "number" ? json["nr_of_installments"] : 0,
            amount: typeof json["amount"] === "string" ? json["amount"] : "",
            title:  typeof json["title"] === "string" ? json["title"] : "",
            phone: typeof json["phone"] === "string" ? json["phone"] : "",
            ready_for_sign: typeof json["ready_for_sign"] === "boolean" ? json["ready_for_sign"] : false,
            is_enable_to_sign: typeof json["is_enable_to_sign"] === "boolean" ? json["is_enable_to_sign"] : false,
            is_contract_downloadable: typeof json["is_contract_downloadable"] === "boolean" ? json["is_contract_downloadable"] : false
        }
    }
    
    static payment_methods_factory = (json:any):PaymentMethodInterface => {
        
        return {
            id: typeof json["ID"] === "string" ? json["ID"] : "",
            created_by_id: typeof json["CreatedByID"] === "string" ? json["CreatedByID"] : "",
            name: typeof json["Name"] === "string" ? json["Name"] : "",
            type: typeof json["Type"] === "number" ? json["Type"] : 0,
            code: typeof json["Code"] === "string" ? json["Code"] : "",
            identifier: typeof json["Identifier"] === "string" ? json["Identifier"] : "",
            iban_disb_shop: typeof json["IbanDisbShop"] === "string" ? json["IbanDisbShop"] : "",
            phone_disb_shop: typeof json["PhoneDisbShop"] === "string" ? json["PhoneDisbShop"] : "",
            img: ""
        }
    }
    
    static loan_application_types_factory = (json: any): LoanApplicationTypesInterface => {
        
        let obj:LoanApplicationTypesInterface = {}
        
        application_keys.map((k:ApplicationsAndCrLineStatuses) => {
            
            let key = k.toUpperCase()
            
            if(json[key]){
                
                obj[k] = Array.isArray(json[key]) ? json[key].map((js) => {
                    return this.application_factory(js)
                }) : []
                
                obj[k] = obj[k]?.sort((a:any , b:any ) => {
                    return   new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                });
                
            }
        })
        
        return obj;
    }
    
    static payment_methods_keys: (keyof PaymentMethodsObjInterface)[] = [
        "unknown",
        "mia",
        "online_wallet",
        "bank",
        "refinancing",
        "cash"
    ]
    
    static payment_methods_obj_factory = (json:any):PaymentMethodsObjInterface => {
        let obj:PaymentMethodsObjInterface = {}

        const serverKeyMap: Partial<Record<keyof PaymentMethodsObjInterface, string>> = {
            mia: "MIA",
        }

        function capitalizeFirstLetter(key: string): string {
            return key.charAt(0).toUpperCase() + key.slice(1);
        }

        this.payment_methods_keys.map((k) => {
            let key = serverKeyMap[k] ?? capitalizeFirstLetter(k)

            if(json[key]){
                obj[k] = Array.isArray(json[key]) ? json[key].map((js) => {
                    return this.payment_methods_factory(js)
                }) : []
            }
        })

        return obj;
    }
    
    static application_status_simplification = (x:string):ApplicationStatus => {
        let arg = x as ApplicationsAndCrLineStatuses
        
        if (arg === ApplicationsAndCrLineStatuses.unknown || arg === ApplicationsAndCrLineStatuses.failed ) {
            return "application_err";
            
        } else if ( arg === ApplicationsAndCrLineStatuses.canceled) {
            return "canceled";
            
        }else if ( arg === ApplicationsAndCrLineStatuses.rejected) {
            return "rejected";
            
        } else if (arg === ApplicationsAndCrLineStatuses.pending_approval ||  arg === ApplicationsAndCrLineStatuses.submitting || arg === ApplicationsAndCrLineStatuses.pending_submission || arg === ApplicationsAndCrLineStatuses.more_data_and_verified || arg === ApplicationsAndCrLineStatuses.more_data_and_not_verified || arg === ApplicationsAndCrLineStatuses.transmission_error ) {
            return "pending";
            
        } else if (arg === ApplicationsAndCrLineStatuses.approved || arg === ApplicationsAndCrLineStatuses.approved_and_payment_pending || arg === ApplicationsAndCrLineStatuses.disbursed || arg === ApplicationsAndCrLineStatuses.approved_and_received || arg === ApplicationsAndCrLineStatuses.approved_and_checked || arg === ApplicationsAndCrLineStatuses.closed) {
            return "approved";
            
        } else if (arg === ApplicationsAndCrLineStatuses.approved_and_not_verified) {
            return "sign_with_kyc";
            
        } else if (arg === ApplicationsAndCrLineStatuses.approved_and_need_sign) {
            return "sign";
            
        } else if (arg === ApplicationsAndCrLineStatuses.approved_and_not_valid_data) {
            return "no_valid_data";
            
        }else if (arg === ApplicationsAndCrLineStatuses.loan_already_exist) {
            return "loan_already_exist";

            
        } else  {
            return "";
        }
        
    }
    
    static date_formating = (date:string) => {
        return new Date(date).getTime();
    }
    
    static notification_type_factory = (x:number):NotificationType => {
        if (x === 0) {
            return "unknown";
        } else if (x === 1) {
            return "identity_card_passed";
        } else if (x === 2) {
            return "liveness_passed";
        } else if (x === 3) {
            return "first_face_comparison_passed";
        } else if (x === 4) {
            return "second_face_comparison__passed";
        } else if (x === 5) {
            return "identity_card_failed";
        } else if (x === 6) {
            return "liveness_failed";
        } else if (x === 7) {
            return "first_face_comparison_failed";
        } else if (x === 8) {
            return "second_face_comparison_failed";
        } else if (x === 9) {
            return "loan_status_changed";
        } else if (x === 10) {
            return "contract_signed_successful";
        } else if (x === 11) {
            return "cr_line_application_status_changed";
        } else if (x === 12) {
            return "cr_line_application_status_changed_and_amount_changed";
        } else if (x === 13) {
            return "loan_installment_after";
        } else if (x === 14) {
            return "loan_installment_before";
        } else if (x === 15) {
            return "loan_payment";
        } else if (x === 16) {
            return "added_attempt_doc_card";
        }else if (x === 17) {
            return "added_attempt_liveness";
        } else if (x === 18) {
            return "loan_status_changed_not_valid";
        } else if (x === 19) {
            return "loan_data_changed";
        } else if (x === 20) {
            return "reset_kyc";
        } else if (x === 21) {
            return "loan_status_rejected";
        } else if (x === 22) {
            return "loan_status_pre_approved";
        } else if (x === 23) {
            return "expire_kyc_30_days";
        } else if (x === 24) {
            return "expire_kyc_20_days";
        } else if (x === 25) {
            return "expire_kyc_10_days";
        } else if (x === 26) {
            return "expire_kyc_5_days";
        } else if (x === 27) {
            return "expire_kyc_3_days";
        } else if (x === 28) {
            return "expire_kyc_2_days";
        } else if (x === 29) {
            return "expire_kyc_1_days";
        } else if (x === 30) {
            return "asp_kyc_conflict";
        } else if (x === 31) {
            return "admin_custom_notification";
        } else  {
            return "";
        }
    }
    
    static notification_info_type = (x:NotificationType):NotificationInfoType => {
        if(
            x === "first_face_comparison_failed" ||
            x === "second_face_comparison_failed" ||
            x === "liveness_failed" ||
            x === "identity_card_failed" ||
            x === "loan_installment_before" ||
            x === "loan_installment_after" ||
            x === "loan_status_changed_not_valid" ||
            x === "loan_status_rejected" ||
            x === "expire_kyc_30_days" ||
            x === "expire_kyc_20_days" ||
            x === "expire_kyc_10_days" ||
            x === "expire_kyc_5_days" ||
            x === "expire_kyc_3_days" ||
            x === "expire_kyc_2_days" ||
            x === "expire_kyc_1_days" ||
            x === 'asp_kyc_conflict'

        ) {
            return "danger"
        } else if (
            x === "loan_status_changed" ||
            x === "unknown" ||
            x === "added_attempt_doc_card" ||
            x === "added_attempt_liveness" ||
            x === "loan_data_changed" ||
            x === 'admin_custom_notification'
        ) {
            return "info"
        } else if(
            x === "first_face_comparison_passed" ||
            x === "identity_card_passed" ||
            x === "liveness_passed" ||
            x === "second_face_comparison__passed" ||
            x === "cr_line_application_status_changed" ||
            x === "contract_signed_successful" ||
            x === "cr_line_application_status_changed_and_amount_changed" ||
            x === "loan_payment"

        ) {
            return "success"
        } else return "info"
    }
    
    static notification_factories = (json:any):NotificationInterface => {
        return {
            id: typeof json["id"] === "string" ? json["id"] : "",
            type: this.notification_type_factory(json["type"])  ,
            related_id: typeof json["related_id"] === "string" ? json["related_id"] : "",
            data: json["data"],
            created_at: this.date_formating(json["created_at"]) || 0,
            
            is_read: json["notification_meta"]["is_read"],
            meta_id: typeof json["notification_meta"]["id"] === "string" ? json["notification_meta"]["id"] : "",
            read_at: typeof json["notification_meta"]["read_at"] === "string" ? this.date_formating(json["notification_meta"]["read_at"]) : null,
            info_type: this.notification_info_type(this.notification_type_factory(json["type"])),
            original_json: {}
        }
    }
    
}

export default Factories